import React, { useState } from "react"
import PanelLayoutContent from "components/layout/PanelLayoutContent"
import LoadingContainer from "components/shared/LoadingContainer"
import { useCustomQuery } from "hooks/useCustomQuery"
import { Outlet } from "react-router-dom"
import { AdminTransactionsService } from "services/api-service"
import { AdminTransactionType, Page } from "services/api-service/types"
import styled from "styled-components"
import { Row } from "ui/components/atoms/_atoms"
import Switch from "ui/components/atoms/switch"
import { Label } from "ui/components/atoms/typography"
import TransactionList from "views/Admin/Transactions/TransactionList"

const Transactions = () => {
  const [page, setPage] = useState(0)
  const [status, setStatus] = useState("all")

  const { isLoading, data, isRefetching } = useCustomQuery<Page<AdminTransactionType>>(
    { key: ["transactions", status, page] },
    () => AdminTransactionsService.getTransactions(status, page),
  )

  return (
    <>
      <PanelLayoutContent title="Lista transakcji" text="Lista wszystkich transakcji na platformie">
        <Row $marginBottom="S" $justifyContent="flex-end" $alignItems="flex-end">
          <SwitchWrapper
            $justifyContent="space-between"
            $padding="S"
            $background="background"
            $alignItems="center"
          >
            <Label $marginBottom="0" $marginRight="XS">
              Tylko niezapłacone
            </Label>
            <Switch
              name="status"
              value={status === "unpaid"}
              onChange={({ name, value }) => {
                const newStatus = value ? "unpaid" : "all"
                setStatus(newStatus)
              }}
            />
          </SwitchWrapper>
        </Row>
        <LoadingContainer isLoading={isLoading || isRefetching}>
          {data && (
            <TransactionList
              data={data?.content.filter(el => !!el.offer)}
              loading={isLoading}
              totalPages={data.totalPages}
              page={page}
              setPage={setPage}
            />
          )}
        </LoadingContainer>
        <Outlet />
      </PanelLayoutContent>
    </>
  )
}

export default Transactions

const SwitchWrapper = styled(Row)`
  border-radius: ${({ theme }) => theme.variable.borderRadius};
`
